import { useCallback, useState } from 'react';

import { budgetMasterDataClient } from '../api';
import { MasterDataQuestionType, MasterDataWithWorkAndFlowerGift } from '../api/types';
import { useDeathLocation } from 'hooks/useDeathLocation';

export interface BudgetLocationsHook {
  fetchLocations: (
    locationType: MasterDataQuestionType, country: string, province: string, city: string) => void;
  locations: MasterDataWithWorkAndFlowerGift[];
  getLocation: (code: string) => MasterDataWithWorkAndFlowerGift | undefined
}

export const useBudgetLocations = (): BudgetLocationsHook => {
  const [locations, setLocations] = useState<MasterDataWithWorkAndFlowerGift[]>([]);
  const {
    fetchDeathLocations,
  } = useDeathLocation();

  const fetchLocations = async (
    locationType: MasterDataQuestionType,
    country: string,
    province: string,
    city: string,
  ) => {
    if (locationType === MasterDataQuestionType.DEATH) {
      await fetchDeathLocations(city)
        .then((response) => {
          setLocations(response);
          return response;
        })
        .catch(() => {
          setLocations([]);
        });
    } else {
      await budgetMasterDataClient
        .GetLocations(locationType, country, province, city)
        .then((response) => {
          setLocations(response);
          return response;
        })
        .catch(() => {
          setLocations([]);
        });
    }
  };

  const getLocation = useCallback(
    (code: string) => locations?.find((location) => location.code === code),
    [locations],
  );

  return {
    fetchLocations,
    getLocation,
    locations,
  };
};
